import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(relativeTime)

type DateInput = string | Date

const formatDateValue = (date: DateInput, pattern: string): string => dayjs(date).format(pattern)

/** Numeric date only, e.g. '2024-01-02'. */
export const formatDateOnly = (date: DateInput): string => formatDateValue(date, 'YYYY-MM-DD')

/** Human-readable date only, e.g. '2 Jan 2024'. */
export const formatDateOnlyLong = (date: DateInput): string => formatDateValue(date, 'D MMM YYYY')

/** Compact human-readable date, e.g. 'Jan 2'. */
export const formatDateShort = (date: DateInput): string => formatDateValue(date, 'MMM D')

/** Compact human-readable date range, e.g. 'Jan 2, 24 - Feb 3, 24'. */
export const formatDateRangeShort = (startDate: DateInput, endDate: DateInput): string =>
  `${formatDateValue(startDate, 'MMM D, YY')} - ${formatDateValue(endDate, 'MMM D, YY')}`

/** Numeric date and time, e.g. '2024-01-02 03:04'. */
export const formatDateTime = (date: DateInput): string => formatDateValue(date, 'YYYY-MM-DD HH:mm')

/** Human-readable date and time, e.g. '2 Jan 2024, 03:04'. */
export const formatDateTimeLong = (date: DateInput): string =>
  formatDateValue(date, 'D MMM YYYY, HH:mm')

/** Relative date and time, e.g. '2 hours ago' or 'in 3 days'. */
export const formatDateTimeRelative = (date: DateInput): string => {
  return dayjs().to(dayjs(date))
}

/** Time only, e.g. '03:04'. */
export const formatTimeOnly = (date: DateInput): string => formatDateValue(date, 'HH:mm')
export const diffDates = (startDate: string, endDate: string, unit: 'day' | 'month' | 'year') => {
  return dayjs(startDate).diff(endDate, unit)
}
